import React, { Component } from 'react';
import Formulario from './PrestamoForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";
const valEmp = __CONFIG__.empresa;

class Prestamo extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, getModulo, listarColaborador, leer,
        limpiarDatos } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
        }
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        if (valEmp === 'fage'){
            getModulo(modulo[6],modulo[5])
        }else{
            getModulo(modulo[5],modulo[4]);
        }
        listarColaborador();
        limpiarDatos();
    }
    
    render(){
        const { loader, modulo, emp, registroPrestamo,
            datosColaborador, cargo, tipo, modificarPrestamo } = this.props;
        const { crear } = this.state;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    crear = {crear}
                    modulo = {modulo}
                    emp = {emp}
                    registroPrestamo = {registroPrestamo}
                    cargo = {cargo}
                    tipo = {tipo}
                    modificarPrestamo = {modificarPrestamo}
                    datosColaborador = {datosColaborador}
                />
            </LoadMask>
        );
    }
}

export default Prestamo;